import React, { Component } from "react";
import { Upload, Button, Dropdown, Menu } from "antd";
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { updateFilesList, updateRootFolder, updateMetadata } from '../../actions/UploadFolderAction'
import "./UploadFolderDragzone.css";
import UploadIcon from "../../assets/icons/upload-icon.svg";
import { mapFilesList, changeOpacity, removeDuplicatesByProperty } from "../upload-folder/UploadFolderUtils";
import UploadPopup from "./upload-popup/UploadPopup";
import { getCustomsClients } from "../../utils";

const Dragger = Upload.Dragger

class UploadFolderDragzone extends Component {

    constructor(props) {
        super(props);
        this.state = {
            popup: {
                visible: false,
                x: 0,
                y: 73,
                blocked: true
            }
        };

        this.isCustom = getCustomsClients().map(r => r._id).includes(this.props.client._id);
    }

    handleUpload = (fileList) => {
        const fileListMapped = mapFilesList(fileList);
        const cleaned = removeDuplicatesByProperty(fileListMapped, "path");
        this.setState({
            popup: {
                ...this.state.popup,
                visible: false,
                blocked: true
            }
        })
        this.props.updateFilesList(cleaned);
        this.props.updateMetadata({
            showUploadFolderModal: true
        });
    };

    handleClickDragZone = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const tableRect = event.currentTarget.getBoundingClientRect(); // Get the table's bounding rectangle
        const relativeX = event.clientX - tableRect.left; // Calculate relative X position
        const relativeY = event.clientY - tableRect.top; // Calculate relative Y position
        this.setState({
            popup: {
                visible: true,
                x: relativeX + 150,
                y: relativeY + 180
            }
        })
    }

    render() {
        const {
            fileList,
            intl,
            newColor,
            // client
        } = this.props;

        const {
            popup
        } = this.state;

        let cssCustomUploadBanner = "custom-dragzone"
        let customWhite = ''
        if (this.isCustom) {
            const customClient = getCustomsClients().filter(r => r._id === this.props.client._id)
            cssCustomUploadBanner = customClient && customClient.length > 0
                ? customClient[0].cssUploadBanner
                : "custom-dragzone"
            customWhite = 'custom-dragzone-color-text'
        }

        return (
            <React.Fragment>
                <div
                    className={`container ${cssCustomUploadBanner}`}
                >
                    <Dragger
                        type="file"
                        name='dragger'
                        showUploadList={false}
                        multiple
                        directory
                        beforeUpload={() => {
                            return false;
                        }}
                        fileList={fileList}
                        onChange={info => {
                            return this.handleUpload(info.fileList);
                        }}
                        // disabled = {selectingOptions}
                        style={{
                            marginTop: "3%",
                            backgroundColor: changeOpacity(newColor, 20)
                        }}
                    >
                        <div
                            className="upload-container"
                            onClick={this.handleClickDragZone}
                        >
                            <div
                                className="upload-container-s1"
                            >
                                <span>
                                    <span className={`title-s1 ${customWhite}`}>{intl.formatMessage({ id: "upload-folder-dragzone-submessage1" })}</span>
                                    <span className="title-s2" style={{
                                        color: this.isCustom ? "#fff" : newColor
                                    }}>{intl.formatMessage({ id: "upload-folder-dragzone-submessage2" })}</span>
                                </span>
                                <p className={`subtitle-1 ${customWhite}`}>
                                    {intl.formatMessage({ id: "upload-folder-dragzone-message" })}
                                </p>
                            </div>
                            <div
                                className="upload-container-s2"
                            >
                                <Dropdown
                                    overlay={<Menu>
                                        <Menu.Item
                                            key="1"
                                            onClick={(param) => param.domEvent.stopPropagation()}
                                        >
                                            <Upload
                                                name='dragger_files'
                                                multiple
                                                showUploadList={false}
                                                fileList={[]}
                                                beforeUpload={() => {
                                                    return false;
                                                }}
                                                onChange={info => {
                                                    return this.handleUpload(info.fileList)
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        width: 180,
                                                    }}
                                                >
                                                    {intl.formatMessage({ id: "upload-folder-dragzone-select-files" })}
                                                </div>
                                            </Upload>
                                        </Menu.Item>
                                        <Menu.Item key="2" onClick={(param) => param.domEvent.stopPropagation()}>
                                            <Upload
                                                name='dragger_folders'
                                                multiple
                                                directory
                                                showUploadList={false}
                                                fileList={[]}
                                                beforeUpload={() => {
                                                    return false;
                                                }}
                                                onChange={info => {
                                                    return this.handleUpload(info.fileList)
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        width: 180,
                                                    }}
                                                >
                                                    {intl.formatMessage({ id: "upload-folder-dragzone-select-folders" })}
                                                </div>
                                            </Upload>
                                        </Menu.Item>
                                    </Menu>}
                                    trigger={['click']}
                                    style={{
                                        zIndex: 10
                                    }}
                                >
                                    <Button
                                        type="primary"
                                        className="main-button"
                                        onClick={e => {
                                            e.stopPropagation()
                                            e.preventDefault()
                                        }}
                                        style={{ backgroundColor: newColor, borderColor: newColor }}
                                    >
                                        <div
                                            className="button-content"
                                        >
                                            <div>
                                                {intl.formatMessage({ id: "upload-folder-dragzone-select" })}
                                            </div>
                                            <img src={UploadIcon} alt="upload" />
                                        </div>
                                    </Button>
                                </Dropdown>
                            </div>
                        </div>
                    </Dragger>
                </div>
                <UploadPopup
                    visible={popup.visible}
                    x={popup.x}
                    y={popup.y}
                    onFolderSelected={(info) => {
                        return this.handleUpload(info.fileList)
                    }}
                    onFileSelected={(info) => {
                        return this.handleUpload(info.fileList)
                    }}
                    intl={intl}
                    onMouseEnter={() => {
                        this.setState({
                            popup: {
                                ...popup,
                                blocked: false
                            }
                        })
                    }}
                    onMouseLeave={() => {
                        // if(popup.visible && !popup.blocked){
                        //     this.setState({
                        //         popup: {
                        //             ...popup,
                        //             visible: false,
                        //             blocked: true
                        //         }
                        //     })
                        // }
                    }}
                />

            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        fileList: state.uploadFolder.fileList,
        user: state.authUser.user,
        newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
        client: state.client.data
    }
}

const mapDispatchToProps = {
    updateFilesList,
    updateRootFolder,
    updateMetadata
}


export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(UploadFolderDragzone)))
